module.exports = __webpack_public_path__ + "static/img/hysteroscope-6.f7eec37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/hysteroscopepic/hysteroscope-6.jpg
// module id = FNMa
// module chunks = 51